/**
 * Extracts a query parameter from the URL hash fragment.
 * Handles hash-based routing: /#/form?f=123&t=456
 */
export function getParameterFromUrl(paramName) {
  const url = window.location.href;

  const fragmentIndex = url.indexOf('#');
  const fragment = url.slice(fragmentIndex + 1);

  const queryParamsIndex = fragment.indexOf('?');
  const queryParams = fragment.slice(queryParamsIndex + 1);

  const urlParams = new URLSearchParams(queryParams);
  const paramValue = urlParams.get(paramName);

  if (paramValue) {
    return paramValue;
  }
}
